import pinia from '@/stores'
import router from '@/router'
import vuetify from './vuetify'

export function registerPlugins(app) {
  app
    .use(pinia)
    .use(vuetify)
    .use(router)
}
